export const registrationModule = {
    state() {
        return {
            reg: {
                "phoneNumber": ""
            }
        }
    },
    mutations: {
        updatePhoneNumber(state, destination) {
            state.reg.phoneNumber = destination
        }
    }
}